import type { FetchUserContextApiResponse, ChangeUserProjectActionOptions } from './types';
import * as t from './actionTypes';

export const acceptGdpr = () => ({ type: t.ACCEPT_GDPR_REQUEST });

export const changeUserProject = (projectId: number, options?: ChangeUserProjectActionOptions) => ({
  type: t.CHANGE_USER_PROJECT_REQUEST,
  projectId,
  ...options,
});

export const fetchUserProjectRequest = () => ({
  type: t.FETCH_USER_CONTEXT_REQUEST,
});

export const fetchUserProjectResponse = (response: FetchUserContextApiResponse) => ({
  type: t.FETCH_USER_CONTEXT_RESPONSE,
  response,
});

export const viewAsUserRequest = (email: string) => ({ type: t.VIEW_AS_USER_REQUEST, email });
export const viewAsUserResponse = () => ({ type: t.VIEW_AS_USER_RESPONSE });
